import KeenSlider from 'keen-slider';
import "../../css/views/home.scss";

const autoplay = ( run, sliderInstance, interval = 0 ) => {

	clearInterval( interval )
	interval = setInterval( () => {
		if ( run && sliderInstance ) {
			sliderInstance.next()
		}
	}, 3000 )
}

const sliderDefaults = ( options = {} ) => {
	const { applyDots = false, applyAutoplay = false, refCarousel = "", refDots = "" } = options

	return ( {
		created: function ( instance ) {
			const referredSlider = refCarousel ? document.getElementById( refCarousel ) : null

			document
				.getElementById( "arrow-left" )
				.addEventListener( "click", () => instance.prev() )
			document
				.getElementById( "arrow-right" )
				.addEventListener( "click", () => instance.next() )

			if ( applyDots ) {

				const dots_wrapper = document.getElementById( refDots )
				const slides = referredSlider.querySelectorAll( ".keen-slider__slide" )

				slides.forEach( ( el, idx ) => {

					const dot = document.createElement( "button" )
					dot.classList.add( "dot" )
					dots_wrapper.appendChild( dot )
					dot.addEventListener( "click", () => instance.moveToSlide( idx ) )
				} )
			}

			if ( applyAutoplay ) {
				autoplay( true, instance )
			}

			updateClasses( { instance, applyDots } )
		},
		slideChanged( instance ) {
			updateClasses( { instance, applyDots } )
		},
	} )
}

const sliderAutoplayProps = () => {
	return ( {
		controls: false,
		loop: true,
		duration: 1000,
		dragStart: ( instance ) => autoplay( false, instance ),
		dragEnd: ( instance ) => autoplay( true, instance ),
		breakpoints: {
			"(min-width: 992px)": {
				...sliderDefaults( { applyAutoplay: false } ),
				duration: 500,
			},
		},
	} )
}


const projectCarousel = document.getElementById( "projectCarousel" );

new KeenSlider( "#headerSliderText", {
	...sliderDefaults( { applyAutoplay: true, refCarousel: "headerSliderText" } ),
	...sliderAutoplayProps()
} )
new KeenSlider( '#headerSliderImgs', {
	...sliderDefaults( { applyAutoplay: true, refCarousel: "headerSliderImgs" } ),
	...sliderAutoplayProps(),
	vertical: true,
} )

function updateClasses( props ) {
	const { instance, applyDots = false } = props

	const slide = instance.details().relativeSlide

	const arrowLeft = document.getElementById( "arrow-left" )
	const arrowRight = document.getElementById( "arrow-right" )
	const currCounter = document.getElementById( "currentSlide" )
	const sliderLength = document.getElementById( "sliderLength" )

	currCounter.innerHTML = slide + 1
	sliderLength.innerHTML = instance.details().size

	slide === 0
		? arrowLeft.classList.add( "arrow--disabled" )
		: arrowLeft.classList.remove( "arrow--disabled" )
	slide === instance.details().size - 1
		? arrowRight.classList.add( "arrow--disabled" )
		: arrowRight.classList.remove( "arrow--disabled" )

	if ( applyDots ) {
		const dots = document.querySelectorAll( ".dot" )
		dots.forEach( ( dot, idx ) => {
			idx === slide
				? dot.classList.add( "isActive" )
				: dot.classList.remove( "isActive" )
		} )
	}
}